import { render, staticRenderFns } from "./AddUserToUsergroupDialog.vue?vue&type=template&id=9df750f4&lang=pug"
import script from "./AddUserToUsergroupDialog.vue?vue&type=script&lang=js"
export * from "./AddUserToUsergroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports